import axios from 'axios';
import { backendUrl } from '../constants/urls';
import clientApi from '../constants/urls';

const createEventCategory = (values: any) => {
	return clientApi.post(`${backendUrl}/eventCategory`, values);
};

const retrieveEvents = () => {
	return clientApi.get(`${backendUrl}/eventCategory`);
};

//@ts-ignore
const updateEventCategory = (id, event) => {
	return clientApi.put(`${backendUrl}/eventCategory/${id}`, event);
};

const deleteEventCategory = (id: string) => {
	return clientApi.delete(`${backendUrl}/eventCategory/${id}`);
};

const eventCategoryService = {
	createEventCategory,
	retrieveEvents,
	updateEventCategory,
	deleteEventCategory,
};

export default eventCategoryService;
